import createLrsMiddleware from '../shared/createLrsMiddleware';
import { getReadingLrsObjectId, getReadingLrsExtensions } from './lrsHelpers';

const lrsMiddlewareInstance = createLrsMiddleware(getReadingLrsObjectId, getReadingLrsExtensions);

export default lrsMiddlewareInstance;
